import Vue from 'vue';
import messageVue from './message.vue';
import merge from '@/utils/merge';

const defaults = {
    content: "当前网络不好！请重新下载~",
    confirmText: "重新下载",
    confirmClose: true, //确认之后是否关闭
    showCloseBtn: false,
    confirmCallback: null,
    closeCallback: null
};

const MessageConstructor = Vue.extend(messageVue);
const Message = (options => {
    options = merge({}, defaults, options);
    let instance = new MessageConstructor({
        data: options
    });
    instance._vm = instance.$mount()
    instance._el = instance.$el
    instance._instance = instance
    document.body.appendChild(instance.$el) // 把生成的提示的dom插入body中
    return instance;
})

export default Message